import React from "react";
import "./Produk.scss";
import data from "./data.json";
import Card from "../../Component/Card Viola/cardviola";
import Vicenteimages from "../../media/Hot/Vicente/Vicente";
import Newimages from "../../media/Hot/Altara/New";
import Citrusimages from "../../media/Hot/Citrus/Citrus";

const imageMap = {
  Vicenteimages,
  Newimages,
  Citrusimages,

  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="produk" className="produk">
      <h1>Hot Products </h1>
      <h2>Grand Wisata Hot Products</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
